import React from "react";
import styles from "./PageHeader.module.scss";
import NavigationBar from "../NavigationBar/NavigationBar";
export default function PageHeader() {
  return (
    <div className={styles["page-header"]}>
      {/* <TopBar /> */}
      <div className={styles.navbar}>
        <NavigationBar HomePage />
      </div>
    </div>
  );
}
